import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { strings } from '../../../localization';

export class SpeedZoneLabel extends React.PureComponent {

    static propTypes = {
        speedLimit: PropTypes.number.isRequired,
        maxSpeed: PropTypes.number.isRequired, /* false will return null */
        startDate: PropTypes.instanceOf(Date).isRequired,
        endDate: PropTypes.instanceOf(Date).isRequired,
        unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {

        var distanceUnitsAreMetric = this.props.unitOfMeasure === 'METRIC';

        var maxSpeed = this.props.maxSpeed;
        var speedLimit = this.props.speedLimit;
        if (distanceUnitsAreMetric === false) {
            maxSpeed = Math.round(maxSpeed / 1.60934) // convert to miles (stored on Raven as kms, regardless of user preference)
            speedLimit = Math.round(speedLimit / 1.60934) // convert to miles (stored on Raven as kms, regardless of user preference)
        }

        const overLimitAmount = maxSpeed - speedLimit;
        var summary = "";
        if (distanceUnitsAreMetric) {
            summary = strings.formatString(strings.event_speeding_up_to_x_kph_over_limit, overLimitAmount);
        } else {
            summary = strings.formatString(strings.event_speeding_up_to_x_mph_over_limit, overLimitAmount);
        }

        return (
            <div className="speed-zone-badge">
                {summary}
            </div>
        )
    }
}

export class SpeedZoneBadge extends React.PureComponent {

    static propTypes = {
        speedLimit: PropTypes.number.isRequired,
        maxSpeed: PropTypes.number.isRequired, /* false will return null */
        startDate: PropTypes.instanceOf(Date).isRequired,
        endDate: PropTypes.instanceOf(Date).isRequired,
        unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {

        var distanceUnitsAreMetric = this.props.unitOfMeasure === 'METRIC';

        var maxSpeed = this.props.maxSpeed;
        var speedLimit = this.props.speedLimit;
        if (distanceUnitsAreMetric === false) {
            maxSpeed = Math.round(maxSpeed / 1.60934) // convert to miles (stored on Raven as kms, regardless of user preference)
            speedLimit = Math.round(speedLimit / 1.60934) // convert to miles (stored on Raven as kms, regardless of user preference)
        }

        const overLimitAmount = maxSpeed - speedLimit;
        var units = distanceUnitsAreMetric ? strings.kph : strings.mph;

        return (
            <div className="speed-badge">
                <div className="max-speed">
                    <div className="value">
                        {maxSpeed}
                    </div>
                    <div className="units">
                        {units}
                    </div>
                </div>
                <div className="speed-limit">
                    <div className="value">
                        {speedLimit}
                    </div>
                    <div className="units">
                        {strings.speed_limit_label_short}
                    </div>
                </div>
            </div>
        )
    }
}
